<template>
  <div class="alignCenter">
    <van-nav-bar
      id="reset"
      title="检测预约"
      left-text=""
      right-text=""
    />
    <!-- 已经预约的提示 -->
    <h3 style="text-align:center;margin-bottom:40px">预约结果</h3>
    <div v-if="hasBooked" style="padding-bottom:80px;">
      <img :src="successIcon" class="success_icon"/>
      <h4>恭喜您预约成功</h4>
      <h5 style='color:lightgray'>请保持预留手机号码畅通等待客服</h5>
      <!-- <img :src="checkBookImg" class="btn"> -->
      <van-button type="info" block color="#4285C3" class="btn" @click="checkBookInfo">查看预约结果</van-button>
      <van-button type="info" block color="#4285C3" class="btn" @click="backToIndex" style="margin-bottom:80px">返回首页</van-button>

    </div>


    <!-- 还未预约提示 -->
    <div v-else style="margin-bottom:80px;padding-bottom:80px;">
      <img :src="haveNotBookedImg" class="infoImg"/>
      <h5>您还没有相关预约记录</h5>
      <!-- <h5>请先前往预约页面预约！</h5> -->
      <van-button type="info" block color="#4285C3" @click="goToReport" class="btn"
        style="margin-bottom:20px"
        v-show="hasLatestCheckReport"
        >查看上次诊断报告</van-button
      >
      <van-button type="info" block color="#4285C3" class="btn" @click="backToIndex" style="margin-bottom:80px">返回首页</van-button>

    </div>
    <van-tabbar  
      class="bottomBar" 
      active-color="#FFFFFF" inactive-color="#FFFFFF"
    >
      <van-tabbar-item name="home" icon="home-o" @click="goToIndex">首页</van-tabbar-item>
      <van-tabbar-item name="setting" icon="setting-o" @click="goToBookRecord">预约记录</van-tabbar-item>
    </van-tabbar>
    
  </div>
  
</template>

<script type="text/ecmascript-6">
import successIcon from "../../../assets/success.png"
import haveNotBookedImg from "../../../assets/haveNotBooked.png"
// import checkBookImg from "../../../assets/checkBookBtn.png"
// import backToIndexImg from "../../../assets/backToIndexBtn.png"
import { getUserBookedResource ,getUserAllExam } from "../../../api/userService";

export default {
  name: "login",
  data() {
    return {
      teleNum: sessionStorage.getItem("teleNum"),
      hasBooked: false,
      successIcon,
      haveNotBookedImg,
      hasLatestCheckReport:false,
      // checkBookImg,
      // backToIndexImg,
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    this._getUserBookedResource();
    this._getUserAllExam();
  },
  // 里面的函数只有调用才会执行
  methods: {
    //获取用户预约的资源
    _getUserBookedResource() {
      getUserBookedResource(this.teleNum)
        .then((res) => {
          //如果接口调用成功，且有预约资源（res.data存在 ）
          if (res.success) {
            //如果有预约记录,则将状态设置为已经预约
            if (res.data) {
              this.hasBooked = true;
            }
          } else {
            this.hasBooked = false;
          }
        })
        .catch((e) => {
          this.$message({
            message: e,
            type: "error",
          });
        });
    },
    //获取用户所有的检测记录；
    _getUserAllExam(){
      getUserAllExam(this.teleNum)
      .then(res => {
        if(res.success){
          if(res.data[0].length >0 ) {
            this.hasLatestCheckReport = true;
          }
          else{
            this.hasLatestCheckReport = false;
          }
        }
        else{
          this.$message({ message: res.description, type: "error" });
        }
      })
      .catch(e =>{
        console.log(e)
      })
    },
    checkBookInfo() {
      this.$router.push({ path: "/appIndex/appointmentDetail" });
    },
    backToIndex() {
      this.$router.push({ path: "/appIndex/main" });
    },
    goToBookRecord() {
      this.$router.push({ path: "/appIndex/appointmentResult" });
    },
    goToIndex(){
      this.$router.push({ path: "/appIndex/main" });
    },
    goToReport() {
      this.$router.push({ path: "/appIndex/checkReport" });
    },

  },
};
</script>

<style lang=less scoped>

/**style for top bar */
.van-nav-bar {
  background: linear-gradient(to right, #77bbe3, #1270c6);
}
#reset /deep/ .van-ellipsis {
  font-size: 18px;
  color: white !important;
}
#reset /deep/ .van-nav-bar__text {
  color: white !important;
}
/** top bar style end*/

.alignCenter{
  text-align: center;
}
.btn{
  margin:20px auto;
  width:70%;
  border-radius:10px;
}

.infoImg{
  width:50%;
  height:auto;
}

.success_icon{
  width:40px;
  height:auto;
  margin-bottom:10px;
}

.bottomBar{
  background:linear-gradient( to bottom, #77BBE3, #1270C6);
}
</style>